'use client'

import React, { ReactElement, ReactNode } from 'react'
import { AsyncSingleSelectInput, FormField, SingleSelectInput } from '../../../FormElements'
import { FilterItem, FilterItemProps } from '../FilterItem'
import {
    AsyncSingleSelectInputProps,
    SelectInputProps,
    SelectOption,
    SelectOptionValue,
    SingleSelectInputProps,
} from '../../../../types/SelectInput'
import { useSelectFilter } from '../hooks/useSelectFilter'

export interface SelectFilterProps
    extends Omit<SelectInputProps, 'value' | 'name' | 'onChange' | 'isMulti'>,
        Pick<FilterItemProps, 'width'> {
    /** "name" of object that should be filtered on. Will be used to create unique ID for "Filter" Object. This should be exactly the key that the API needs to filter on */
    name: string
    label?: string | ReactNode
}

export const SelectFilter = ({ label, options, name, width, ...props }: SelectFilterProps): ReactElement => {
    const { fieldName, selectedValue, setSelectedValue } = useSelectFilter(name, props.defaultValue)
    const { isAsync, ...selectProps } = props

    return (
        <FilterItem width={width}>
            <FormField
                label={label}
                name={fieldName}
                className="w-full"
                disabled={props.disabled}
                readOnly={props.readOnly}
            >
                {isAsync ? (
                    <AsyncSingleSelectInput
                        {...(selectProps as AsyncSingleSelectInputProps)}
                        value={selectedValue as SelectOptionValue}
                        options={options}
                        onChange={(option: SelectOption) => setSelectedValue(option?.value)}
                        name={fieldName}
                    />
                ) : (
                    <SingleSelectInput
                        {...(selectProps as SingleSelectInputProps)}
                        value={selectedValue as SelectOptionValue}
                        options={options}
                        onChange={(option: SelectOption) => setSelectedValue(option?.value)}
                        name={fieldName}
                    />
                )}
            </FormField>
        </FilterItem>
    )
}
